import type { Resource } from '../../';
export const country_countries_PT: Resource = {"default":"Portugal"};
